import { LIST_FEATURE_FLAGS, useFeatureFlag } from '@diamond/shared/utils';
import {
  AdminMenuList,
  AdminMenuListLayout,
} from '@diamond/sol-admin/components';
import {
  AddShoppingCartOutlined,
  AutoGraphOutlined,
  CategoryOutlined,
  ConfirmationNumberOutlined,
  ContactsOutlined,
  ExtensionOutlined,
  InventoryOutlined,
  LocalOfferOutlined,
  ManageSearchOutlined,
  PeopleAltOutlined,
  ReceiptLongOutlined,
  ScaleOutlined,
  StorageOutlined,
  TakeoutDiningOutlined,
} from '@mui/icons-material';

const adminMenus: AdminMenuList = [
  {
    id: 1,
    href: '/account',
    label: 'Account & Contact',
    icon: ContactsOutlined,
    requiredRoles: ['super_admin'],
  },
  {
    id: 2,
    href: '/activities',
    label: 'Activities',
    icon: AutoGraphOutlined,
    requiredRoles: ['super_admin', 'cs_katalog', 'cs_cabang'],
  },
  {
    id: 3,
    href: '/user',
    label: 'Users',
    icon: PeopleAltOutlined,
    requiredRoles: ['super_admin'],
  },
  {
    id: 5,
    href: '/banners',
    label: 'Banner Management',
    icon: CategoryOutlined,
    requiredRoles: ['super_admin'],
  },
  {
    id: 6,
    href: '/minimum-order',
    label: 'Minimum Order Management',
    icon: AddShoppingCartOutlined,
    requiredRoles: ['super_admin'],
  },
  {
    id: 7,
    href: '/keywords',
    label: 'Keyword Management',
    icon: ManageSearchOutlined,
    requiredRoles: ['super_admin'],
  },
  {
    id: 8,
    href: '/highlight',
    label: 'Highlight Management',
    icon: ExtensionOutlined,
    requiredRoles: ['super_admin'],
  },
  {
    id: 9,
    href: '/promo',
    label: 'Promo Management',
    icon: LocalOfferOutlined,
    requiredRoles: ['super_admin'],
  },
  {
    id: 10,
    href: '/recipe',
    label: 'Resep Management',
    icon: TakeoutDiningOutlined,
    requiredRoles: ['super_admin'],
  },
  {
    id: 13,
    href: '/product-limitation',
    label: 'Product Limitation Order',
    icon: InventoryOutlined,
    requiredRoles: ['super_admin'],
  },
  {
    id: 14,
    href: '/daily-stock',
    label: 'Daily Stock Config',
    icon: StorageOutlined,
    requiredRoles: ['super_admin'],
  },
];

export function HomePage() {
  const isVoucherMenuEnabled = useFeatureFlag(
    LIST_FEATURE_FLAGS.FF_VOUCHERS_MENU,
    false
  );

  const isCollectionManagementEnabled = useFeatureFlag(
    LIST_FEATURE_FLAGS.FF_LHC_COLLECTION_MANAGEMENT,
    false
  );

  const isEstimatedWeightProductEnabled = useFeatureFlag(
    LIST_FEATURE_FLAGS.FF_ESTIMATED_WEIGHT_PRODUCT,
    false
  );

  let menus: AdminMenuList = [...adminMenus];

  if (isVoucherMenuEnabled) {
    menus = [
      ...menus,
      {
        id: 11,
        href: '/vouchers',
        label: 'Voucher Management',
        icon: ConfirmationNumberOutlined,
        requiredRoles: ['super_admin'],
      },
    ];
  }

  if (isCollectionManagementEnabled) {
    menus = [
      ...menus,
      {
        id: 12,
        href: '/collection-management',
        label: 'Collection Management',
        icon: ReceiptLongOutlined,
        requiredRoles: ['super_admin', 'collector'],
      },
    ];
  }

  if (isEstimatedWeightProductEnabled) {
    menus = [
      ...menus,
      {
        id: 15,
        href: '/estimated-weight-product',
        label: 'Estimated Weight Product',
        icon: ScaleOutlined,
        requiredRoles: ['super_admin'],
      },
    ];
  }

  return <AdminMenuListLayout menus={menus} />;
}
